/* esm.sh - rxjs@7.8.1/dist/esm/internal/operators/concatAll */
import{mergeAll as r}from"./mergeAll.mjs";function t(){return r(1)}export{t as concatAll};
//# sourceMappingURL=concatAll.mjs.map